export default {"src":"https://web.cdn.greenlight.com/2.1272.0/_next/static/media/check.1e17d5b2.svg","height":69,"width":86,"blurWidth":0,"blurHeight":0};